class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.classList.remove('force-hidden');
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    // iOS Safari can leave the overlay's compositor layer stuck visible (seen since the
    // payment-button iframes were added). Fully removing it from the render tree once the
    // visibility transition ends forces a proper repaint.
    this.addEventListener(
      'transitionend',
      () => {
        if (!this.classList.contains('active')) {
          this.classList.add('force-hidden');
        }
      },
      { once: true }
    );
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
const menuDrawer = document.querySelector('header-drawer');
const hamburgerIcon = document.querySelector('.icon-hamburger');
const closeIcon = document.querySelector('.icon-close');


customElements.define('cart-drawer-items', CartDrawerItems);

class ShippingProgressBar extends HTMLElement {
  connectedCallback() {
    const fill = this.querySelector('.cart-drawer__shipping-bar-fill');
    if (!fill) return;
    const targetPercent = this.dataset.percent || 0;
    fill.style.width = '0%';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fill.style.width = `${targetPercent}%`;
      });
    });
  }
}

customElements.define('shipping-progress-bar', ShippingProgressBar);

class CompleteSetSync extends HTMLElement {
  connectedCallback() {
    const code = this.dataset.code || 'none';

    // The nudges block (and this element with it) re-renders on every cart
    // change, not just ones that affect discount eligibility. Skip the
    // apply/clear round-trip entirely when the target code hasn't actually
    // changed, so unrelated cart edits (e.g. removing an unrelated item)
    // don't cause a visible refresh/flicker.
    if (sessionStorage.getItem('completeSetDiscountCode') === code) {
      return;
    }
    sessionStorage.setItem('completeSetDiscountCode', code);

    document.querySelectorAll('.cart-drawer__discounts, .totals').forEach((el) => {
      el.classList.add('cart-drawer__price-syncing');
    });

    const request =
      code && code !== 'none'
        ? fetch(`/discount/${code}`)
        : fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' }),
          });

    request
      .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // Order-level discounts (COMPLETESET) show in the footer, but
        // product-level discounts (SHORTPAIR) show inside the cart item row
        // itself, so cart-drawer-items has to be refreshed too or that
        // badge never appears until a full reload. Shipping bar is left out
        // since it isn't affected by the discount and re-rendering it just
        // causes unnecessary flicker/re-animation.
        const selectors = ['cart-drawer-items', '.cart-drawer__discounts', '.totals'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        document.querySelectorAll('.cart-drawer__discounts, .totals').forEach((el) => {
          el.classList.remove('cart-drawer__price-syncing');
        });
      });
  }
}

customElements.define('complete-set-sync', CompleteSetSync);

